import { render, staticRenderFns } from "./widget-dropdown.vue?vue&type=template&id=55fc81d7&scoped=true"
import script from "./widget-dropdown.vue?vue&type=script&lang=ts"
export * from "./widget-dropdown.vue?vue&type=script&lang=ts"
import style0 from "./widget-dropdown.vue?vue&type=style&index=0&id=55fc81d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc81d7",
  null
  
)

export default component.exports